/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UpdateUserStatusRequestDto = {
    status: UpdateUserStatusRequestDto.status;
};

export namespace UpdateUserStatusRequestDto {

    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        SUSPENDED = 'SUSPENDED',
        PENDING = 'PENDING',
    }


}

